// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  width: 100dvw;
  height: 100dvh;
  /* padding: 0.75rem; */
  display: flex;
  gap: 0.75rem;
  overflow: hidden;
}

:root .LightTheme {
  --Background: #eaebed;
  --Foreground: #f5f5f5;
  --TextColor: #212121;
  --AccentColor: #102c97;
  --Invitation: #d7edff;
  --Reinitiated: #dafff6;
  --Accepted: #dad4ff;
  --Inprogress: #f8e7ab;
  --Pending: #b2e7ff;
  --Completed: #c0ffc3;
  --Cancelled: #ffbdbd;
  --Stroke: #b2dcff;
  --Hover: #fafafa;
}

.LightTheme,
.DarkTheme {
  transition: all 0.3s ease-in-out;
  width: 100vw;
  height: 100vh;
  color: #333333;
}

:root .DarkTheme {
  --Background: #252525;
  --Foreground: #2b2b2b;
  --TextColor: #e2e2e2;
  --AccentColor: #09a5e0;
  --Invitation: #0053964d;
  --Reinitiated: #00ffc14d;
  --Accepted: #806bff4d;
  --Inprogress: #ffc8034d;
  --Pending: #0db2fc4d;
  --Completed: #1eff274d;
  --Cancelled: #ff43434d;
  --Stroke: #393939;
  --Hover: #323232;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
  padding: 0;
}

.Ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.CenterDiv {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 1200px) {
  :root {
    font-size: 15px;
  }
}

@media (max-width: 1200px) {
  :root {
    font-size: 13px;
  }
}

@media (max-width: 800px) {
  :root {
    font-size: 11px;
  }
}

@media (max-width: 500px) {
  :root {
    font-size: 9px;
  }
}

button {
  border: none;
  background: none;
  cursor: pointer;
}

input:focus,
select:focus,
textarea:focus {
  outline: none;
}

*::-webkit-scrollbar {
  width: 0.375rem;
  height: 0.375rem;
}

*::-webkit-scrollbar-track {
  background-color: #edecec3f;
  border-radius: 10px;
}

*::-webkit-scrollbar-thumb {
  background-color: var(--Stroke);
  border-radius: 10px;
}

*::-webkit-scrollbar-thumb:hover {
  background: var(--Pending);
}

input[type="password"]::-ms-reveal,
input[type="password"]::-ms-clear {
  display: none;
}

input[type="password"]::-webkit-contacts-auto-fill-button,
input[type="password"]::-webkit-credentials-auto-fill-button {
  display: none;
}

input[type="password"]::-webkit-contacts-auto-fill-button:focus,
input[type="password"]::-webkit-credentials-auto-fill-button:focus {
  display: none;
}

/* 
button:focus-visible, 
a:focus-visible, 
input:focus-visible {
  outline: 0.125rem solid var(--AccentColor);
  outline-offset: -0.125rem;
}

button:focus:not(:focus-visible), 
a:focus:not(:focus-visible), 
input:focus:not(:focus-visible) {
  outline: none;
} */


html, body {
  overscroll-behavior: none;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;;;;;;;;;GAYG;;;AAGH;EACE,yBAAyB;AAC3B","sourcesContent":[".App {\n  width: 100dvw;\n  height: 100dvh;\n  /* padding: 0.75rem; */\n  display: flex;\n  gap: 0.75rem;\n  overflow: hidden;\n}\n\n:root .LightTheme {\n  --Background: #eaebed;\n  --Foreground: #f5f5f5;\n  --TextColor: #212121;\n  --AccentColor: #102c97;\n  --Invitation: #d7edff;\n  --Reinitiated: #dafff6;\n  --Accepted: #dad4ff;\n  --Inprogress: #f8e7ab;\n  --Pending: #b2e7ff;\n  --Completed: #c0ffc3;\n  --Cancelled: #ffbdbd;\n  --Stroke: #b2dcff;\n  --Hover: #fafafa;\n}\n\n.LightTheme,\n.DarkTheme {\n  transition: all 0.3s ease-in-out;\n  width: 100vw;\n  height: 100vh;\n  color: #333333;\n}\n\n:root .DarkTheme {\n  --Background: #252525;\n  --Foreground: #2b2b2b;\n  --TextColor: #e2e2e2;\n  --AccentColor: #09a5e0;\n  --Invitation: #0053964d;\n  --Reinitiated: #00ffc14d;\n  --Accepted: #806bff4d;\n  --Inprogress: #ffc8034d;\n  --Pending: #0db2fc4d;\n  --Completed: #1eff274d;\n  --Cancelled: #ff43434d;\n  --Stroke: #393939;\n  --Hover: #323232;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n  margin: 0;\n  padding: 0;\n}\n\n.Ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.CenterDiv {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (min-width: 1200px) {\n  :root {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 1200px) {\n  :root {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 800px) {\n  :root {\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 500px) {\n  :root {\n    font-size: 9px;\n  }\n}\n\nbutton {\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n\ninput:focus,\nselect:focus,\ntextarea:focus {\n  outline: none;\n}\n\n*::-webkit-scrollbar {\n  width: 0.375rem;\n  height: 0.375rem;\n}\n\n*::-webkit-scrollbar-track {\n  background-color: #edecec3f;\n  border-radius: 10px;\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: var(--Stroke);\n  border-radius: 10px;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background: var(--Pending);\n}\n\ninput[type=\"password\"]::-ms-reveal,\ninput[type=\"password\"]::-ms-clear {\n  display: none;\n}\n\ninput[type=\"password\"]::-webkit-contacts-auto-fill-button,\ninput[type=\"password\"]::-webkit-credentials-auto-fill-button {\n  display: none;\n}\n\ninput[type=\"password\"]::-webkit-contacts-auto-fill-button:focus,\ninput[type=\"password\"]::-webkit-credentials-auto-fill-button:focus {\n  display: none;\n}\n\n/* \nbutton:focus-visible, \na:focus-visible, \ninput:focus-visible {\n  outline: 0.125rem solid var(--AccentColor);\n  outline-offset: -0.125rem;\n}\n\nbutton:focus:not(:focus-visible), \na:focus:not(:focus-visible), \ninput:focus:not(:focus-visible) {\n  outline: none;\n} */\n\n\nhtml, body {\n  overscroll-behavior: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
